export interface IClock {
    today(): Date;
    now(): Date;
}

export class Clock implements IClock {
    /**
     * Returns today's date at midnight (start of day) in the timezone of the local machine that this code is running
     * from.
     *
     * @returns Today's date at midnight (start of day)
     */
    public today(): Date {
        const now = this.now();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
        return today;
    }

    public now(): Date {
        return new Date();
    }

    public nowMs(): number {
        return Date.now();
    }
}

export const clock = new Clock();
